import {TestType} from "./testTypes";

export type SchoolSubjectType = 1 | 2 | 3 | 4 | 22 | 37 | 33 | 34 | 30;

export interface ISubjects {
    id: string | number;
    name: string;
    numberId?: number;
    newStandardId?: number;
}

const SCHOOL_SUBJECTS: ISubjects[] = [
    {name: "Comunicare în limba română (CLR)", id: 2, newStandardId: 1},
    {name: "Limba și literatura română", id: 4, newStandardId: 2},
    {name: "Matematică și explorarea mediului", id: 3, newStandardId: 3},
    {name: "Matematică", id: 1, newStandardId: 4},
    {name: "Istorie", id: 22, newStandardId: 5},
    {name: "Geografie", id: 37, newStandardId: 6},
    {name: "Biologie", id: 33, newStandardId: 7},
    {name: "Chimie", id: 34, newStandardId: 8},
    {name: "Fizică", id: 30, newStandardId: 9},
]

export const SUBJECT_TYPES: Record<TestType, ISubjects[]> = {
    school: SCHOOL_SUBJECTS,
    training: SCHOOL_SUBJECTS,
    bac: [
        {name: "Bacalaureat Știinte/Tehnic", id: "bac-mate", numberId: 901},
        {name: "Bacalaureat Matematică/Informatică", id: "bac-mate-info", numberId: 902},
        {name: "Bacalaureat Română", id: "bac-romana", numberId: 903},
        {name: "Bacalaureat Istorie", id: "bac-istorie", numberId: 904},
    ],
    evaluate: [
        {name: "Evaluare Națională Matematică (VIII)", id: "evaluare-nationala-mate", numberId: 48},
        {name: "Evaluare Națională Română (VIII)", id: "evaluare-nationala-romana", numberId: 39},
    ],
    numericLiteracy: [
        {name: "Test rapid", id: "fast"},
        {name: "Test evaluare", id: "evaluate"},
        {name: "Test screener ICAN (I-IV)", id: "ican"},
    ],
    literacy: [],
    digitalLiteracy: [],
    scientificLiteracy: [],
    customTest: [],
}

export const getSchoolSubjectStandardTypeId = (id: number) => SCHOOL_SUBJECTS.find((subject) => subject.id === id);
export const getSubjectType = (type: string) => SUBJECT_TYPES[type as TestType];


